import { Avatar, Box, IconButton, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText, Menu, MenuItem, TableCell, TableRow } from "@mui/material";
import CustomTable from "../../../core/components/common/custom-table.component";
import moment from "moment";
import CustomClickableLabel from "../../../core/components/ui/custom-clickable-label.component";
import CustomStatusLabel from "../../../core/components/ui/custom-status-label.component";
import CustomListviewLoader from "../../../core/components/common/custom-listview-loader.component";
import { useNavigate } from "react-router-dom";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CustomChipComponent from "../../../core/components/common/custom-chip.component";
import DevicesIcon from '@mui/icons-material/Devices';
import { useEffect, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import theme from "../../../core/components/layout/theme";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useGuard } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";
import { Tab } from "bootstrap";
import CustomTableLoaderComponent from "../../../core/components/common/custom-table-loader.component";



function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
}

const CustomMenuPopperComponent = (props) => {
    const org_uid = new URLSearchParams(window.location.search).get("org_uid");
    const {data, setOpen, theme, customIconStyles, onAction} = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const {hasPermission} = useGuard();

    const navigate = useNavigate();

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleUpdateStatus = () => {
        setOpen(true);
    }

    const menuItems = [
        {
            icon: <VisibilityIcon fontSize="small" sx={{color: theme.palette.primary.main}}  />,
            label: "View User",
            onClick: () => navigate('/user/view?user_uid=' + data.user_uid +'&org_uid=' + org_uid),
            requiredPermission: permissions.users.VIEW_USER_PROFILE,
        },
        {
            icon: <DevicesIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "Update User",
            onClick: () => navigate('/user/update?user_uid=' + data.user_uid),
            requiredPermission: permissions.users.UPDATE_ACCOUNT,
        },
    ].filter((item) => hasPermission(item.requiredPermission))

    return (
        <>
  
            {menuItems.length > 0 &&
                <>
                    <IconButton onClick={handleClick}>
                        <MoreVertIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        PaperProps={{style: {maxHeight: 300}}}
                    >
                        {menuItems?.map((item, index) => (
                            <MenuItem
                                key={index}
                                onClick={() => {
                                    handleClose();
                                    item.onClick();
                                }}
                                sx={{}}
                            >
                                <ListItemIcon sx={customIconStyles}>
                                    {item.icon}
                                </ListItemIcon>
                    
                                <ListItemText sx={{ml: "-3px"}} primary={item.label} />
                            </MenuItem>
                        ))}
                    </Menu>
                </>
            }
        </>
    );
};

export default function UserListComponent (props) {

    const {userList, loading} = props;
    const navigate = useNavigate();
    const [dialog, setDialog] = useState({ open: false, type: null, action: null });

    const openDialog = (type, action) => {
        setDialog({ open: true, type, action });
    };

    const closeDialog = () => {
        setDialog({ open: false, type: null, action: null });
    };

    useEffect(() => {
        console.log("user list bbbb", userList, loading);
    }, [JSON.stringify(userList)])

    
    const headers = [ 
        { label: "User" },
        { label: "Profile Type" },
        { label: "Role" },
        { label: "Status" },
        { label: "Birthdate" },
        { label: "Created At" },
        { label: "Actions" },
    ]

    const PageLoader = () => {
        return (
            <CustomListviewLoader />
        )
    }

    return(
        <Box>
            {loading ?
                <Box sx={{mt: 3}}>
                    <CustomTableLoaderComponent headers={headers} hasAction={false} />
                </Box>
            :
                <CustomTable headers={headers}>
                    {
                        userList?.length > 0 ? (
                          userList?.map((row) => {

                                const userInfo = row.user_info || {};


                                const formattedBirthdate = moment(userInfo.birthdate).format("MMMM DD, YYYY");
                                const formattedLastModified = moment(userInfo.created_at).format("MMMM DD YYYY, h:mm:ss a");

                                console.log('aaaaaaaaaaaaaaaaaaaaa', userInfo)

                                return (
                                    <TableRow key={row.id}>
                                        <TableCell >
                                            <List >
                                                <ListItem>
                                                    <ListItemAvatar>
                                                        <Avatar {...stringAvatar(userInfo.firstname + " " + userInfo.lastname)} />
                                                    </ListItemAvatar>
                                                    <ListItemText primary={userInfo.firstname + " " + userInfo.lastname} secondary={userInfo.email} />
                                                </ListItem>
                                            </List>
                                        </TableCell>
                                        <TableCell>
                                            {row.profile_type}
                                        </TableCell>
                                        <TableCell>
                                            {row.role ? row.role : "N/A"}
                                        </TableCell>
                                        <TableCell>
                                            <CustomChipComponent category="userStatus"
                                            label={(userInfo.status === "Active") ? "Active" 
                                                : 
                                                    (userInfo.status === "Deactivated") ? "Deactivated"
                                                :
                                                    userInfo.status
                                            }
                                            />
                                        </TableCell>
                                        <TableCell>{formattedBirthdate}</TableCell>
                                        <TableCell>{formattedLastModified}</TableCell>
                                        <TableCell>
                                            <CustomMenuPopperComponent
                                                data={userInfo}
                                                onAction={openDialog}
                                                theme={theme}
                                            />
                                            </TableCell>
                                    </TableRow>
                                );
                            })
                        ) : (
                            <TableRow>
                                <TableCell colSpan={headers.length} align="center">
                                    No available account to display
                                </TableCell>
                            </TableRow>
                        )

                    }
                </CustomTable>
            }          
        </Box>
    )
}